export default "__VITE_ASSET__RuJH4$pYLyc17aYY5wBHaw__"